import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Belegerfassung(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Belege erfassen war noch nie so einfach"
      subtitle="Fotografieren, hochladen, fertig. Saldify erkennt automatisch alle relevanten Daten aus Ihren Belegen und ordnet sie der richtigen Kategorie zu."
      heroImage="/screenshots/hero-belege-erfassen.webp"
      heroImageAlt="Saldify Belegliste: erkannte Händler, Beträge und automatisch zugeordnete Buchungskonten"
      features={[
        {
          title: 'KI-gestützte Texterkennung',
          description: 'Unsere intelligente OCR erkennt Beträge, Daten, Lieferanten und Steuersätze automatisch.',
        },
        {
          title: 'Mobile App',
          description: 'Fotografieren Sie Belege unterwegs mit der Saldify App für iOS und Android.',
        },
        {
          title: 'E-Mail-Import',
          description: 'Leiten Sie digitale Belege einfach an Ihre persönliche Saldify-Adresse weiter.',
        },
        {
          title: 'Automatische Kategorisierung',
          description: 'Belege werden automatisch den richtigen Ausgabenkategorien zugeordnet.',
        },
        {
          title: 'Duplikatserkennung',
          description: 'Saldify erkennt doppelte Belege und warnt Sie vor versehentlicher Doppelerfassung.',
        },
        {
          title: 'GoBD-konform',
          description: 'Alle Belege werden revisionssicher und unveränderbar archiviert.',
        },
      ]}
      sections={[
        {
          title: 'Belege einfach fotografieren',
          description: 'Mit der Saldify Mobile App erfassen Sie Belege in Sekunden. Einfach abfotografieren – die KI erledigt den Rest. Keine manuelle Dateneingabe mehr.',
          bullets: [
            'Automatische Kantenerkennung',
            'Optimierung von Helligkeit und Kontrast',
            'Sofortige Texterkennung (OCR)',
            'Offline-Modus für unterwegs',
          ],
          imageSide: 'right',
        },
        {
          title: 'Alle Belege an einem Ort',
          description: 'Im Beleg-Posteingang landen alle Ihre Ausgabenbelege – egal ob per App, E-Mail oder manuell hochgeladen. Prüfen und bestätigen Sie die erkannten Daten mit einem Klick.',
          image: '/screenshots/hero-belege-erfassen.webp',
          imageAlt: 'Beleg-Posteingang mit Monatsfilter, Saldo und automatisch erkannten Belegdaten',
          bullets: [
            'Zentraler Posteingang für alle Belege',
            'Schnelle Freigabe mit Tastaturkürzeln',
            'Kommentare und Notizen hinzufügen',
            'Belege Projekten oder Kostenstellen zuordnen',
          ],
          imageSide: 'left',
        },
        {
          title: 'Nahtlose Integration mit Banking',
          description: 'Verknüpfen Sie Belege automatisch mit Ihren Banktransaktionen. Saldify erkennt zusammengehörige Buchungen und schlägt die Zuordnung vor.',
          bullets: [
            'Automatische Zuordnung zu Transaktionen',
            'Offene Posten auf einen Blick',
            'Lückenlose Dokumentation',
            'Export für den Steuerberater',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Nie wieder Belege abtippen"
      ctaDescription="Testen Sie die intelligente Belegerfassung von Saldify und sparen Sie Stunden an manueller Arbeit."
    />
  );
}
